<section class="legal-chart" aria-label="Total Legal Repayments by month">
  @if (loading) {
    <div class="chart-loading"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div>
  } @else if (bars.length) {
    <div class="chart-dashboard">
      <div class="chart-layout">
        <aside class="chart-y-axis" aria-label="Sum of Payment Amount axis">
          <span class="y-axis-title">Sum of Payment Amount</span>
          <div class="y-axis-ticks">
            @for (tick of yAxisTicks; track tick) { <span>{{ formatAxisAmount(tick) }}</span> }
          </div>
        </aside>
        <div #chartScroll class="chart-scroll" (scroll)="onChartScroll($event)">
          <div class="chart-content" [style.width.px]="chartWidth">
            <p-chart type="bar" height="100%" [data]="chartData" [options]="chartOptions" [responsive]="true" ariaLabel="Legal payment amount by month" />
          </div>
        </div>
      </div>
      <aside #metricsScroll class="chart-summary" aria-label="Legal monthly values" (scroll)="onMetricsScroll($event)">
        <table>
          <thead><tr><th>Month</th><th>Metric</th><th>Legal</th></tr></thead>
          <tbody>
            @for (bar of barsByNewestMonth; track bar.month) {
              <tr><td rowspan="2" class="month-cell">{{ formatMonth(bar.month) }}</td><td>Sum</td><td>{{ formatAmount(bar.amount) }}</td></tr>
              <tr><td>Record Count</td><td>{{ formatCount(bar.count) }}</td></tr>
            }
          </tbody>
        </table>
      </aside>
    </div>
  } @else {
    <div class="chart-empty">No Legal repayments were found.</div>
  }
</section>
